export function isCrmObjectType(s) {
  if (!s || typeof s !== 'string') return false;
  const maybeTypeMatch = s.match(/\d+-\d+/);
  return maybeTypeMatch ? s.indexOf(maybeTypeMatch[0]) === 0 : false;
}